import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'skeleton-story-item',
  templateUrl: './skeleton-story-item.component.html',
  styleUrls: ['./skeleton-story-item.component.scss']
})
export class SkeletonStoryItemComponent implements OnInit, OnChanges {
  // Input data
  @Input() isListView: boolean = false;
  @Input() showDate: boolean = true;
  @Input() showTags: boolean = true;
  @Input() showAuthor: boolean = true;
  @Input() showMedia: boolean = true; // New: Control media section visibility
  @Input() mediaType: 'image' | 'video' | 'mixed' = 'mixed'; // New: Media type
  @Input() showHeader: boolean = false; // New: Control header visibility
  @Input() showDescription: boolean = true; // New: Control description visibility
  @Input() showContributors: boolean = false; // New: Control contributors section
  @Input() imageHeight: number = 225;
  @Input() titleLines: number = 2;
  @Input() descriptionLines: number = 3;
  @Input() tagCount: number = 3;
  @Input() contributorCount: number = 2; // New: Number of contributor avatars

  // Public variables
  public titleHeight: number = 27;
  public descriptionHeight: number = 20;

  constructor() { }

  ngOnInit() {
    this.calculateDimensions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['titleLines'] || changes['descriptionLines'] || changes['isListView']) {
      this.calculateDimensions();
    }
  }

  // Private functions
  private calculateDimensions(): void {
    // Calculate title height based on number of lines
    this.titleHeight = this.titleLines * 27;
    
    // Calculate description height based on number of lines
    this.descriptionHeight = this.descriptionLines * 20;
    
    // Adjust image height for list view
    if (this.isListView) {
      this.imageHeight = Math.min(this.imageHeight, 180);
    }
  }

  // Public functions
  public getTagArray(): number[] {
    return Array(this.tagCount).fill(0).map((x, i) => i);
  }

  public getContributorArray(): number[] {
    return Array(this.contributorCount).fill(0).map((x, i) => i);
  }

  public get mediaColumnClass(): string {
    if (this.isListView) {
      return 'col-12 col-sm-4';
    }
    return 'col-lg-2 col-md-3';
  }

  public get contentColumnClass(): string {
    if (this.isListView) {
      return 'col-12 col-sm-8';
    }
    return 'col-lg-9 col-md-8';
  }

  public get shouldShowMediaSection(): boolean {
    return this.showMedia;
  }

  public get isVideoType(): boolean {
    return this.mediaType === 'video' || this.mediaType === 'mixed';
  }

  public get isImageType(): boolean {
    return this.mediaType === 'image' || this.mediaType === 'mixed';
  }
}
